<style rel="stylesheet/scss" lang="scss" scoped="scoped">
.contentflex{
  background-color: #F9FCFF;
}
  .product-con {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    padding-top: 64px;
    padding-bottom: 100px;
    .newsContents {
      width:1100px;
      margin: 0 auto;
      a,
      img {
        display: block;
        width: 100%;
        border-radius: 24px;
        box-shadow: 4px 4px 4px 0px #f3f6fc;
      }

      .productLi{
      	display: block;
      	position: relative;
      }
      .li-margin-bottom{
      	margin-bottom: 64px;
      }
      .abs-btn{
      	display: block;
      	position: absolute;
      	left: 88%;
		    top: 82%;
		    transform: translate(-50%,-50%);
      	width: 120px;
      	font-size: 16px;
      	line-height: 40px;
      	background-color: #FFFFFF;
      	color: orange;
      	font-weight: 700;
      	border-radius: 6px;
      	text-align: center;
      	cursor: pointer;
      }
    }
  }

</style>
<template>
  <div class="health">
    <Head :selectindex="selectindex"></Head>
    <div class="contentflex">
      <div class="product-con">
        <div class="newsContents">
          <ul class="productList">
          	<li class="productLi li-margin-bottom" v-for="(item,index) in productList" :index="index">
              <a :href="item.linkUrl">
                <img :src="item.imgUrl" />
              </a>
              <!-- <a :href="item.linkUrl" class="abs-btn">立即查看</a> -->
           </li>
          </ul>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
  import Head from '../components/headercontent'
  import Foot from '../components/footercontent'
  import Service from '../common/service'

  export default {
    name: 'home',
    data() {
      return {
        selectindex: 1,
        productList: [],
        relatedList: [],
      }
    },
    created() {
			this.getProductList()
    },
    mounted() {

    },
    methods: {
			getProductList() {
        Service.banner().getbanner({},  6).then(response => {
          this.productList = response.data;
        }, err => {
          console.log(err);
        });
      },
    },
    components: {
      Head,
      Foot,
    },
    beforeDestroy() {
      $('.navbar').removeClass('fixed-topone');
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/views/product.vue